import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=2b7fb441&scoped=true&"
var script = {}
import style0 from "./toast.vue?vue&type=style&index=0&id=2b7fb441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fb441",
  null
  
)

export default component.exports